import React, { useRef } from "react"
import styles from "./logos_carousel.module.scss"
import classNames from "classnames"
import { router } from "next/dist/client"

export type Logo = {
  src: string
  alt: string
  href?: string
}

type LogosCarouselProps = {
  logos: Logo[]
  className: string
}

export default function LogosCarousel({ logos, className }: LogosCarouselProps) {
  // Internally double the logos array for smooth infinite loop
  const logosToRender = [...logos, ...logos, ...logos]
  const trackRef = useRef<HTMLDivElement>(null)
  return (
    <div className={`${styles.carousel} ${className}`} aria-label="Logo carousel" role="region">
      <div
        onClick={() => {
          const track = trackRef.current
          if (!track) return
          track.style.animationPlayState = track.style.animationPlayState === "paused" ? "running" : "paused"
        }}
        className={styles.track}
        ref={trackRef}
      >
        {logosToRender.map((logo, index) => (
          <div
            style={{
              cursor: logo.href ? "pointer" : "default",
            }}
            onClick={logo.href ? () => window.open(logo.href, "_blank", "noopener,noreferrer") : undefined}
            key={index}
            className={styles.logo}
          >
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </div>
    </div>
  )
}
